<div class="cart-container" [ngClass]="{'cart-container--review': isReviewDrawerVisible()}">
@if (!_options.isClient) {
  <div class="cart-header flex flex-col items-center p-8 border-b">
    @if (isReviewDrawerVisible()) {
      <button class="cart-close-button" mat-icon-button aria-label="Close cart" (click)="viewOptionsClick()">
        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    }
    <!-- Back to courses -->
    <!-- <a class="inline-flex items-center leading-6 text-primary hover:underline">
        <span class="inline-flex items-center">
            <mat-icon
                class="icon-size-5 text-current"
                [svgIcon]="'heroicons_solid:arrow-small-left'"></mat-icon>
            <span class="ml-1.5 font-medium leading-5">Back to courses</span>
        </span>
    </a> -->

    <span class="relative left-auto -right-16 flex justify-center transition-all duration-500" [class.hidden]="isReviewDrawerVisible()">
        <span class="flex items-center">
            <svg class="w-14 h-8 -mr-6" width="45" height="25" viewBox="0 0 45 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M43.2951 3.47877C43.8357 3.59191 44.3656 3.24541 44.4788 2.70484C44.5919 2.16427 44.2454 1.63433 43.7049 1.52119L43.2951 3.47877ZM4.63031 24.4936C4.90293 24.9739 5.51329 25.1423 5.99361 24.8697L13.8208 20.4272C14.3011 20.1546 14.4695 19.5443 14.1969 19.0639C13.9242 18.5836 13.3139 18.4152 12.8336 18.6879L5.87608 22.6367L1.92723 15.6792C1.65462 15.1989 1.04426 15.0305 0.563943 15.3031C0.0836291 15.5757 -0.0847477 16.1861 0.187863 16.6664L4.63031 24.4936ZM43.7049 1.52119C32.7389 -0.77401 23.9595 0.99522 17.3905 5.28788C10.8356 9.57127 6.58742 16.2977 4.53601 23.7341L6.46399 24.2659C8.41258 17.2023 12.4144 10.9287 18.4845 6.96211C24.5405 3.00476 32.7611 1.27399 43.2951 3.47877L43.7049 1.52119Z"
                    fill="currentColor" class="fill-gray-300 dark:fill-gray-700"></path>
            </svg>
            <span class="mt-3 inline-block whitespace-nowrap text-[11px] leading-5 font-semibold tracking-wide uppercase bg-accent-600 text-white rounded-full py-1 px-2.5">Check this out!</span>
        </span>
    </span>

    <!-- Course title & description -->
    <div class="mt-3 text-2xl font-semibold">Your Quotes</div>
    <div *ngIf="view.itin?.content?.itinerary" class="text-secondary">
      <button [matTooltip]="'Capture quote information'" mat-flat-button (click)="openModal(null, 'quote-information')"><span class="inline-flex items-center"><mat-icon class="mr-1.5 icon-size-5" [svgIcon]="'heroicons_outline:book-open'"></mat-icon> {{view.itin.content.itinerary.firstName + ' ' + view.itin.content.itinerary.lastName}}</span></button>
    </div>
    <div *ngIf="!view.itin?.content?.itinerary" class="text-secondary">Review your selected services</div>
    <!-- Course time -->
    <!-- <div class="mt-6 flex items-center leading-5 text-md text-secondary">
        <mat-icon
            class="icon-size-5 text-hint"
            [svgIcon]="'heroicons_solid:clock'"></mat-icon>
        <div class="ml-1.5">{{course.duration}} minutes</div>
    </div> -->
  </div>
}

<!-- <div class="flex flex-col items-center mt-5">
  <div class="text-xl text-center font-semibold leading-tight tracking-tight text-secondary">Cart Total</div>
  <div class="text-3xl text-center font-semibold leading-tight tracking-tight">{{getCartTotal() | currency:'ZAR':'symbol-narrow'}}</div>
</div>

<div class="flex flex-row justify-center mt-4" *ngIf="isReviewDrawerVisible()">
<div class="px-3 text-center">
  <p class="text-md font-semibold text-primary-600">{{getCartTotal('flight') | currency:'ZAR':'symbol-narrow'}}</p>
  <p class="text-gray-500 text-sm">Flights</p>
</div>
<div class="px-3 text-center">
  <p class="text-md font-semibold text-primary-600">{{getCartTotal('hotel') | currency:'ZAR':'symbol-narrow'}}</p>
  <p class="text-gray-500 text-sm">Hotel</p>
</div>
<div class="px-3 text-center">
  <p class="text-md font-semibold text-primary-600">{{getCartTotal('transfer') | currency:'ZAR':'symbol-narrow'}}</p>
  <p class="text-gray-500 text-sm">Transfers</p>
</div>
</div> -->

<div class="flex flex-row items-center justify-center mt-5 gap-x-2">
<button class="" mat-flat-button [matTooltip]="isReviewDrawerVisible() ? 'Make changes to selected services' : 'Review selected services'" [color]="isReviewDrawerVisible() ? 'white' : 'accent'" (click)="viewOptionsClick()"><span class="inline-flex items-center"><mat-icon *ngIf="isReviewDrawerVisible()" class="mr-1.5 icon-size-5" [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon> {{isReviewDrawerVisible() ? 'Close' : 'View Options'}}</span></button>

<!-- <button *ngIf="isReviewDrawerVisible() && !_options.isClient" [matTooltip]="'Generate quote reference and capture pax information'" mat-flat-button [color]="isReviewDrawerVisible() ? 'white' : 'accent'" (click)="validateQuote('new-quote')"><span class="inline-flex items-center"><mat-icon class="mr-1.5 icon-size-5" [svgIcon]="'heroicons_outline:book-open'"></mat-icon> Generate Quote</span></button>
<span *ngIf="isReviewDrawerVisible() && !_options.isClient">or </span>
<button *ngIf="isReviewDrawerVisible() && !_options.isClient" [disabled]="!(this.view.itin && this.view.itin.content && this.view.itin.content.itinerary && this.view.itin.content.itinerary.guid)" [matTooltip]="'Create as an option under the same reference'" mat-flat-button [color]="isReviewDrawerVisible() ? 'white' : 'accent'" (click)="validateQuote('new-option')"><span class="inline-flex items-center"><mat-icon class="mr-1.5 icon-size-5" [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon> Add to quote options</span></button> -->
<!-- <button *ngIf="isReviewDrawerVisible() && !_options.isClient" [disabled]="!(this.view.itin && this.view.itin.content && this.view.itin.content.itinerary && this.view.itin.content.itinerary.guid)" [matTooltip]="'Capture pax details and book services'" mat-flat-button [color]="'accent'" (click)="validateQuote('checkout')"><span class="inline-flex items-center">Checkout <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_outline:chevron-double-right'"></mat-icon></span></button> -->
<button *ngIf="isReviewDrawerVisible() && _options.isClient && view.data.cart && view.data.cart && view.data.cart.length > 0" [matTooltip]="'Capture details and request quotation'" mat-flat-button [color]="'accent'" (click)="createItin()"><span class="inline-flex items-center">Checkout <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_outline:chevron-double-right'"></mat-icon></span></button>
<button *ngIf="isReviewDrawerVisible() && !_options.isClient" [disabled]="!(this.view.itin && this.view.itin.content && this.view.itin.content.itinerary && this.view.itin.content.itinerary.guid)" [matTooltip]="'Review all quotation options'" mat-flat-button [color]="'accent'" (click)="openReviewModal()"><span class="inline-flex items-center">Review Quotes<mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_outline:chevron-double-right'"></mat-icon></span></button>

</div>
<app-quote-list (refreshCart)="onRefreshCart()"  *ngIf="view.quotes && this.view.itin || (_options.isClient && view.data.cart && view.data.cart.length > 0)" 
[_view]="view" 
[displayIcons]="false"
[quotes]="view.quotes" 
[isClient]="_options.isClient"
[compactColumns]="_options?.compactColumns"
[showViewAllPax]="false"
[isReviewDrawerVisible]="isReviewDrawerVisible()"
(viewQuote)="validateQuote('view-quote', $event)"
(selectQuote)="selectQuote($event.checked, $event.quote)">
</app-quote-list>

<!-- Quote list -->
<!-- <app-quote-list 
[quotes]="view.quotes" 
[isClient]="_options.isClient"
[tripPoints]="view.trip?.points"
[itin]="view.itin"
[isReviewDrawerVisible]="isReviewDrawerVisible()"
(viewQuote)="validateQuote('view-quote', $event)"
(selectQuote)="selectQuote($event.checked, $event.quote)">
</app-quote-list> -->
<!--  -->
</div>
